import { actionCreatorFactory } from 'typescript-fsa';
import { Resource } from '../../modules/StoryEdit/components/Stream/Editors/TileEditor';

const actionCreator = actionCreatorFactory('Navigation');

export const navigateBack = actionCreator('GO_BACK');

export const gotoSite = actionCreator<string>('GOTO_SITE');

export const replaceSite = actionCreator<string>('REPLACE_SITE');

export const goToShopEntity = actionCreator<{
  resource: Resource;
  isMobile?: boolean;
}>('EXTERNAL_ENTITY');



// WEBPACK FOOTER //
// ./src/store/Navigation/navigation.actions.ts